import { render, staticRenderFns } from "./newProdImg.vue?vue&type=template&id=3c7179c5&scoped=true"
import script from "./newProdImg.vue?vue&type=script&lang=js"
export * from "./newProdImg.vue?vue&type=script&lang=js"
import style0 from "./newProdImg.vue?vue&type=style&index=0&id=3c7179c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7179c5",
  null
  
)

export default component.exports